<script type="text/jsx" lang="jsx">
import mixin from '@/plans/mx/shopping-cart';
import commonMixin from '@/plans/VIDEO_SDK/mixin';
import { BILLING_CYCLE } from "@/common/constants";

export default {
  mixins: [mixin, commonMixin],
  name: 'VideosdkCart',
  methods: {
    $renderPrice() {
      if (!this.mx_plans.length) return;
      return (
        <div class="opc-cart-item">
          {this.mx_plans.map((plan) => {
            return (
              <div>
                {this.mx_title(this.title, this.mx_price(plan))}
                {this.mx_cycle(plan.billing_cycle)}
                {plan.billing_cycle === BILLING_CYCLE.PAY_AS_YOU_GO && this.mx_cycle(BILLING_CYCLE.MONTHLY)}
                {this.mx_edit(plan)}
                {!this.mx_isLastBasePlan && this.mx_remove(plan)}
              </div>
            );
          })}
        </div>
      );
    },
  },
};
</script>
